import makeStyles from "@mui/styles/makeStyles";

export const useDisabledStyles = makeStyles({
  root: {
    opacity: 0.35,
    cursor: "not-allowed",
  },
});
